import React, { useState } from "react";
import { Stage, Sprite , Container, useTick, Graphics} from '@inlet/react-pixi'
import * as PIXI from 'pixi.js';
import Q from './Q.json';

PIXI.settings.SCALE_MODE = PIXI.SCALE_MODES.NEAREST;
const WIDTH = window.innerWidth;
const HEIGHT = window.innerHeight * 0.8;
let key = 0;

const RotatingBunny = () => {
    const [rotation, setRotation] = useState(0);

    useTick((delta) => delta && setRotation(rotation - 0.1 * delta));

    return(
        <Sprite
      image="https://s3-us-west-2.amazonaws.com/s.cdpn.io/693612/IaUrttj.png"
      anchor={0.5}
      scale={4}
      rotation={rotation}
    />
    );
}
const Brick = (stats) => {
    key += 1;
    return(
    <Graphics 
    key={key}
    interactive={true}
    pointerdown={ ()=> stats.onClick(10 * stats.col + stats.num)}
    num={stats.num}
    col={stats.col}
        draw ={ g => {
            g.beginFill(stats.color, 1)
            g.lineStyle(2, stats.color, 1)
            g.drawRoundedRect(stats.posx, stats.posy, stats.width, stats.height)
            g.endFill()
        }}
    />
    )
}
const sumArray = (array) => {
    var s = 0;
    for (let i=0; i<array.length;i++)
    {
        s+= array[i];
    }
    return(s);
}
class Game extends React.Component{
    constructor(props) {
        super(props);
        this.Restart();
    }
    componentDidUpdate(){
        setTimeout(() => {this.go();}, 500);
    }
    go(){
        if(!this.Player1 && !this.Won && this.bot2)
        {
            let act = this.choose_action(this.brick_num);
            console.log(act[0], act[1] - 1);
            this.move(act[0], act[1] - 1);  
        }
        else if(this.Player1 && !this.Won && this.bot1)
        {
            let act = this.choose_action(this.brick_num);
            console.log(act[0], act[1] - 1);
            this.move(act[0], act[1] - 1);  
        }
    }
    get_q_value(state, action)
    {
        let s = "((";
        for (let i = 0; i< state.length - 1; i++)
        {
            s += state[i];
            s += ", "
        }
        s += state[state.length - 1];
        s += "), (";
        s += action[0];
        s += ", ";
        s += action[1];
        s += "))";
        return Q[s]
    }
    choose_action(state)
    {
        let actions = []
        for (let i = 0; i < state.length; i++)
        {
            for (let j = 1; j < state[i] + 1; j++)
            {
                actions = [...actions, [i, j]];
            }
        }
        let best_act = [];
        let max_q = 0;
        let start = true;
        for (let i = 0; i < actions.length; i++)
        {
            if (start)
            {
                start = false;
                max_q = this.get_q_value(state,actions[i]);
                best_act = actions[i];
                continue
            }
            let q = this.get_q_value(state, actions[i]);
            if (q > max_q)
            {
                max_q = q;
                best_act = actions[i];
            }
        }
        return (best_act)
    }
    constructBricks(){
        let tempbricks = []
        let bricknum = this.brick_num.slice();
        for (let i=0; i < bricknum.length; i++)
        {
            for(let j=0; j < bricknum[i]; j++)
            {
                tempbricks = [...tempbricks, {
                    col: i,
                    num: j,
                    id: 10*i +j,
                    width: Math.floor(WIDTH / (bricknum.length * 2)),
                    height: HEIGHT * 0.1,
                    posx: Math.floor((WIDTH) / (bricknum.length * 2) * (i * 2 + 0.5)),
                    posy: HEIGHT * (0.8 - 0.13* j)
                }];
            }
        }
        this.bricks = tempbricks;
        this.forceUpdate();
    }
    move(col, num){
        if (this.brick_num[col] < num + 1) return;
        this.brick_num[col] -= num + 1;
        this.Player1= !this.Player1;
        if (sumArray(this.brick_num) == 0) this.Won = this.Player1 ? 1 : 2;
        this.constructBricks();
    }
    handleClick(id){
        if(!(this.Player1 && this.bot1) && !(!this.Player1 && this.bot2)){
        let col = Math.floor(id/10);
        let num = id%10
        this.move(col, this.brick_num[col] - num - 1);
        }
    }
    Restart(){
        this.start= true;
        this.Player1= true;
        this.brick_num= [1, 3, 5, 7];
        this.bricks= [];
        this.Won= 0;
        this.bot1 = false;
        this.bot2 = false;
        this.constructBricks();
    }
    render(){
        let matched = window.matchMedia('(prefers-color-scheme: dark)').matches || window.matchMedia('(prefers-color-scheme: dark-mode)').matches;
        if (this.start)
        {
            this.start = false;
            return(
                <div>
                <div style={{textAlign: 'center'}}>
                    <h1> This AI is trained itself for 10000 times</h1>
                </div>
                <div style={{textAlign: 'center'}}>
                        <div style={{display: 'inline-flex', alignItems: 'center'}}>
                    <p style={{justifyContent: 'space-around', padding: '10px'}}> Player1 is bot:</p>
                    <label class="switch">
                        <input onClick={() => {this.bot1 = !this.bot1}} type="checkbox"/>
                        <span class="slider round"/>
                    </label>
                    <p style={{padding: '10px'}}> Player2 is bot:</p>
                    <label class="switch">
                        <input onClick={() => {this.bot2 = !this.bot2}} type="checkbox"/>
                        <span class="slider round"/>
                    </label>
                </div>
                </div>
                <div style={{textAlign: 'center'}}>
                    <button className="game-info-button" onClick={() => this.constructBricks()}> Start game</button>
                </div>
                </div>
            );
        }
        let message = this.Player1 ? "Player 1" : "Player 2";
        if (this.Won) {
            message += " Won";
            return(
                <div style={{textAlign: 'center'}}>
                    <h1 style={{paddingTop: '20px'}}> {message}</h1>
                    <button className="game-info-button" onClick={() => this.Restart()}> Restart game</button>
                </div>
            )
        }
        return(
        <div style={{textAlign: 'center', width: '100vw', height:'100vh'}}>
            <h1 style={{paddingTop: '20px'}}> {message}</h1>
        <Stage width={WIDTH} height={HEIGHT} options={{backgroundColor: matched ? 0x000000 : 0xFFFFFF, transparent: true, antialias: true, resolution: (WIDTH / HEIGHT) > 1 ? (HEIGHT / WIDTH) : (WIDTH / HEIGHT), autoresize: true}}>
            {
                this.bricks.map(brick => {
                    return(
                    <Brick onClick={(i) => this.handleClick(i)} color={matched ? 0xFFFFFF : 0x000000} col={brick.col} num={brick.num} width={brick.width} posx={brick.posx} posy={brick.posy} height={brick.height}/>)
                })
            }
          </Stage>
        </div>
        );
    }
}
export default Game;